/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ISeparatorStyleProps, ISeparatorStyles } from '@fluentui/react/lib/Separator';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { LuisSeparator } from 'src/core/components/LuisSeparator';
import { getScopedTheme } from 'src/core/themes/luisStylist';

export type LuisStepperSeparatorProps = {
    isNumeric: boolean;
    horizontal: boolean;
    isCompleted: boolean;
    isContainerFullWidth?: boolean;
};

const stepperTheme = getScopedTheme('LuisStepper');
const separatorStyler = classNamesFunction<ISeparatorStyleProps, ISeparatorStyles>();

const horizontalStyles = separatorStyler({ root: { paddingTop: '20px !important', width: 'auto' } });
const completedStyles = separatorStyler({
    root: {
        selectors: {
            '&::after': { width: '2px', backgroundColor: `${stepperTheme.defaultColor} !important` },
            '&::before': { height: '2px', backgroundColor: `${stepperTheme.defaultColor} !important` }
        }
    }
});
const nonCompletedStyles = separatorStyler({
    root: {
        width: '100%',
        selectors: {
            '&::after': { width: '2px', backgroundColor: `${stepperTheme.inactiveSeparatorColor} !important` },
            '&::before': { height: '2px', backgroundColor: `${stepperTheme.inactiveSeparatorColor} !important` }
        }
    }
});

export const LuisStepperSeparator = (props: LuisStepperSeparatorProps) => {
    const { isNumeric, horizontal, isCompleted, isContainerFullWidth = true } = props;
    const verticalStyles = separatorStyler({
        root: { paddingLeft: isContainerFullWidth && `${isNumeric ? 40 : 12}px !important`, height: isContainerFullWidth ? '36px' : '100%' }
    });

    return (
        <LuisSeparator
            vertical={!horizontal}
            styles={mergeStyleSets(nonCompletedStyles, isCompleted && completedStyles, horizontal ? horizontalStyles : verticalStyles)}
        />
    );
};
